import React from 'react';
import moment from 'moment';
import cn from 'classnames';

import CursorBasedList, { loadViaApi } from '../CursorBasedList';

const WalletTransactions = ({
  userId
}) => {

  const formatCoins = (coins) => {
    const coinTypes = Object.keys(coins).filter(key => key !== 'total' && coins[key] > 0)
    return coinTypes.length == 1 ? coinTypes[0].toUpperCase() : coinTypes.map((key) => {
      return `${coins[key]} ${key.toUpperCase()}`
    }).join(' / ')
  }

  const renderItems = (items) => items.map((usage) => (
    <div key={usage.id} className={cn("Table__row", { 'Table__row--red': usage.amount < 0, 'Table__row--green': usage.amount > 0})}>
      <div className='Table__col Table__col--colored'>{usage.amount}</div>
      <div className='Table__col Table__col--colored'>{usage.description}</div>
      <div className='Table__col Table__col--colored'>{moment.unix(usage.created_at).format('YYYY-MM-DD HH:mm')}</div>
      <div className='Table__col Table__col--colored'>{formatCoins(usage.coins)}</div>
    </div>
  ))

  return (
    <CursorBasedList
      fetchData={loadViaApi(`/${gon.currentProvider}/api/users/${userId}/wallet_transactions`)}
      renderItems={renderItems}
      tableClass='Table--wallet-transactions'
    >
      <div className='Table__row'>
        <div className='Table__col Table__col--th'>Amount</div>
        <div className='Table__col Table__col--th'>Description</div>
        <div className='Table__col Table__col--th'>Date</div>
        <div className='Table__col Table__col--th'>Coin Details</div>
      </div>
    </CursorBasedList>
  )
}

export default WalletTransactions
